import React from "react";
import styles from "../Pricing.module.scss";

function DualPricing({ activeApp }) {
  const getPricingDataById = (id) => {
    let pricing = activeApp?.prices?.find((price) => price.id === id);
    return pricing ? pricing.pivot : { dollars: 0, percent: 0 };
  };

  const hasValidPricing = (pricingId) => {
    const pricing = getPricingDataById(pricingId);
    return pricing.dollars > 0 || pricing.percent > 0;
  };

  return (
    <div className={styles.dual_pricing}>
      {hasValidPricing(35) && (
        <div className={styles.dual_pricing_section}>
          <div className={styles.dual_pricing_list}>
            <div className={styles.dual_pricing_item}>
              <div className={styles.dual_pricing_text}>
                <div className={styles.dual_pricing_top}>
                  <h4 className={styles.dual_pricing_label}>Dual pricing rate</h4>
                </div>
                <div className={styles.dual_pricing_bottom}>
                  <h4 className={styles.dual_pricing_value}>{getPricingDataById(35).percent}%</h4>
                </div>
              </div>
            </div>
              <div className={styles.dual_pricing_item}>
                <div className={styles.dual_pricing_text}>
                  <div className={styles.dual_pricing_top}>
                    <h4 className={styles.dual_pricing_label}>Per Transaction</h4>
                  </div>
                  <div className={styles.dual_pricing_bottom}>
                    <h4 className={styles.dual_pricing_value}>{ getPricingDataById(35)?.dollars ? '$ ' + getPricingDataById(35)?.dollars : '-' }</h4>
                  </div>
                </div>
              </div>

            <div className={styles.dual_pricing_item}>
              <div className={styles.dual_pricing_text}>
                <div className={styles.dual_pricing_top}>
                  <h4 className={styles.dual_pricing_label}>Monthly fee</h4>
                </div>
                <div className={styles.dual_pricing_bottom}>
                  <h4 className={styles.dual_pricing_value}>$ {getPricingDataById(17).dollars}/mo</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DualPricing; 